import { createReducer, on } from '@ngrx/store';
import * as RegionActions from '../../actions/master-data/region.actions';
import { RegionState } from '../../states/master-data/region.state';

export const initialState: RegionState = {
  loading: false, 
  regions: [],
  error: undefined,
  successMessage: ''
};

export const regionReducer = createReducer(
    initialState,
    on(RegionActions.loadRegions, (state) => ({ ...state, loading: true, successMessage: '', error: null })),
    on(RegionActions.loadRegionsSuccess, (state, {regions}) => ({ ...state, loading: false, regions })),
    on(RegionActions.addRegion, (state, {region}) => ({...state, regions: [...state.regions, region]})),
    on(RegionActions.addRegionSuccess, (state, { message }) => ({
        ...state,
        successMessage: message,
        error: null
      })),
    on(RegionActions.updateRegion, (state, {region}) => ({...state, regions: state.regions.map(r => r.id === region.id ? region : r)})),
    on(RegionActions.updateRegionSuccess, (state, { message }) => ({
      ...state,
      successMessage: message ?? 'Region updated successfully'
    })),
    on(RegionActions.deleteRegion, (state, {id}) => ({...state, regions: state.regions.filter(r => r.id !== id)})),
    on(RegionActions.deleteRegionSuccess, (state, { message }) => ({
      ...state,
      successMessage: message ?? 'Region deleted successfully'
    })),
    on(RegionActions.loadRegionsFailure, (state, { error }) => ({ ...state, loading: false, error })),
);